import { Link } from "react-router-dom";

export const Footer = () => (
  <footer
    id="footer"
    className="bg-[var(--dark)] text-[var(--dark-text)]"
    data-testid="site-footer"
  >
    <div className="mx-auto max-w-7xl px-6 py-20 md:px-12">
      <div className="grid gap-14 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <div className="flex items-center">
            <img
              src="/theaidept-logo.png"
              alt="The AI Dept."
              className="h-[50px] w-auto"
            />
          </div>
          <p className="mt-6 max-w-xs text-[15px] leading-relaxed text-white/60">
            One AI department. Every specialist. We build it, run it, and bring
            you the results.
          </p>
        </div>

        <div>
          <p className="mb-5 text-xs uppercase tracking-[0.12em] text-white/40">
            Teams
          </p>
          <ul className="space-y-3 text-[15px] text-white/70">
            <li>
              <Link to="/growth" className="hover:text-[var(--mint)] transition-colors">
                Marketing &amp; Creative
              </Link>
            </li>
            <li>
              <Link to="/workflow" className="hover:text-[var(--mint)] transition-colors">
                Workflow &amp; Automation
              </Link>
            </li>
            <li>
              <Link to="/product" className="hover:text-[var(--mint)] transition-colors">
                Product &amp; Engineering
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="mb-5 text-xs uppercase tracking-[0.12em] text-white/40">
            Solutions
          </p>
          <ul className="space-y-3 text-[15px] text-white/70">
            {[
              ["Real Estate", "/real-estate"],
              ["Healthcare", "/healthcare"],
              ["Legal", "/legal"],
              ["Automotive", "/automotive"],
              ["Home Services", "/home-services"],
            ].map(([s, route]) => (
              <li key={s}>
                <Link to={route} className="hover:text-[var(--mint)] transition-colors">
                  {s}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="mb-5 text-xs uppercase tracking-[0.12em] text-white/40">
            Company
          </p>
          <ul className="space-y-3 text-[15px] text-white/70">
            {[
              ["About us", "/about"],
              ["Our brands", "/our-brands"],
              ["Careers", "/careers"],
              ["Contact", "/contact"],
              ["Pricing", "/pricing"],
              ["Free DNA audit", "/audit"],
            ].map(([s, route]) => (
              <li key={s}>
                <Link to={route} className="hover:text-[var(--mint)] transition-colors">
                  {s}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 text-sm text-white/50 md:flex-row md:items-center md:justify-between">
        <span>© 2026 The AI Dept. · Los Angeles, CA</span>
        <span className="text-[var(--mint)]">We are your unfair advantage.</span>
      </div>
    </div>
  </footer>
);
